import axios from 'axios'
import { getGlobalConfig } from '@/utils/globalConfig'

const cmsClient = axios.create({
  baseURL: getGlobalConfig('CMS_BASE_URL'),
  headers: {
    'Content-type': 'application/json',
    Authorization: `Bearer ${getGlobalConfig('CMS_STATIC_TOKEN')}`
  }
})

async function getGlobalCountrySettingsFromCMS () {
  const queryCountrySettings =
    `query GetCountrySettings($countryCode: String) {
      country_settings(filter: { country_code: { _eq: $countryCode } }) {
        default_locale
        settings_v2
      }
    }`

  const { data, error } = await cmsClient.post(
    getGlobalConfig('GRAPHQL_ENDPOINT'),
    {
      query: queryCountrySettings,
      variables: { countryCode: '*' }
    }
  ).catch((err) => ({ error: err }))

  return { data: data?.data?.country_settings?.[0], error }
}

export { cmsClient, getGlobalCountrySettingsFromCMS }
